/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { TextEditorView } from "./TextEditorView";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var NumericEditorView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(NumericEditorView, _super);
    function NumericEditorView(a, b, c) {
        var _this = _super.call(this, a, b, c) || this;
        _this.p.b1 = "number";
        return _this;
    }
    NumericEditorView.$t = markType(NumericEditorView, 'NumericEditorView', TextEditorView.$);
    return NumericEditorView;
}(TextEditorView));
export { NumericEditorView };
//# sourceMappingURL=NumericEditorView.js.map
